/**
 * Route for `cost-etl-import-ad-network-spend-compute-net-margi`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CostEtlImportAdNetworkSpendComputeNetMargiPage } from "../features/cost-etl-import-ad-network-spend-compute-net-margi/CostEtlImportAdNetworkSpendComputeNetMargiPage";

export const costEtlImportAdNetworkSpendComputeNetMargiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cost-etl-import-ad-network-spend-compute-net-margi",
	component: CostEtlImportAdNetworkSpendComputeNetMargiPage,
});

export default costEtlImportAdNetworkSpendComputeNetMargiRoute;
